
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IStatData } from '@/types/home-types'

@Component({
    name: 'OthersStat',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private stat!: IStatData
    @Prop({ required: true }) private bugCount!: Number
}
